module.exports = __webpack_public_path__ + "media/images/emblems/Sonvilier-coat_of_arms-a3c50f64ae26c41220421a889427e1b7.svg";